export default {
  title: '選擇{type}',
  uploadImage: '上傳圖片',
  uploadVideo: '上傳影片',
  maxCountTip: '最多只能選擇 {count} 個素材',
};
